import axios from "axios";

const prepareData = (data) => {
  return { production_pp_board: data };
};

// Plural Actions
export const GET_PRODUCTION_PP_BOARDS = "get_production_pp_boards";
export const getProductionPpBoards = () => {
  let url = `/production/pp_boards.json`;
  const request = axios.get(url);
  return {
    type: GET_PRODUCTION_PP_BOARDS,
    payload: request,
  };
};

// Singular Actions
export const CREATE_PRODUCTION_PP_BOARD = "create_production_pp_board";
export const createProductionPpBoard = (data) => {
  const url = "/production/pp_boards.json";
  const request = axios({ method: "post", url: url, data: prepareData(data) });
  return {
    type: CREATE_PRODUCTION_PP_BOARD,
    payload: request,
  };
};

export const GET_PRODUCTION_PP_BOARD = "get_production_pp_board";
export const getProductionPpBoard = (id,getStrumisData = false) => {
  let url = `/production/pp_boards/${id}.json`;
  if (getStrumisData) {
    url += "?getStrumisData";
  }

  const request = axios.get(url);
  return {
    type: GET_PRODUCTION_PP_BOARD,
    payload: request,
  };
};

export const UPDATE_PRODUCTION_PP_BOARD = "update_production_pp_board";
export const updateProductionPpBoard = (id, data) => {
  const url = `/production/pp_boards/${id}.json`;
  const request = axios({ method: "patch", url: url, data: prepareData(data) });
  return {
    type: UPDATE_PRODUCTION_PP_BOARD,
    payload: request,
  };
};

export const DESTROY_PRODUCTION_PP_BOARD = "destroy_production_pp_board";
export const destroyProductionPpBoard = (id) => {
  const url = `/production/pp_boards/${id}.json`;
  const request = axios({ method: "delete", url: url });
  return {
    type: DESTROY_PRODUCTION_PP_BOARD,
    payload: request,
    meta: { id: id },
  };
};
